export default "__VITE_ASSET__DjuwPTYZ__"